import { OpportunityListTypeEnum } from "app/pages/sales-intelligence/sub-modules/opportunities/types";

import { CUSTOM_ICONS_CONFIG } from "../constants/constants";
import type { IconConfig } from "../types/types";

export const getIconConfigByType = (listType: OpportunityListTypeEnum): IconConfig => {
    const { defaultIcon, listIcon } = CUSTOM_ICONS_CONFIG;
    return listType === OpportunityListTypeEnum.Shared ? defaultIcon : listIcon;
};
